import { CoverOptionItem } from './types'

export const isCoverOptionActive = (coverOption: CoverOptionItem) =>
  Boolean(coverOption.active)

export const hasCoverOptionItem =
  (coverOption: string | undefined) => (coverOptionItem: CoverOptionItem) =>
    coverOption === coverOptionItem.coverOption
